import { useSyncExternalStore } from 'react';

function subscribe(onChange: () => void): () => void {
  window.addEventListener('online', onChange);
  window.addEventListener('offline', onChange);
  return () => {
    window.removeEventListener('online', onChange);
    window.removeEventListener('offline', onChange);
  };
}

function getSnapshot(): boolean {
  return navigator.onLine;
}

/**
 * Whether the browser says it has a network.
 *
 * `false` is reliable (no interface, airplane mode); `true` only means an
 * interface is up, not that Autopostmate answers. So this drives the offline notice
 * and nothing else: a call that fails while "online" still says so itself
 * (`NETWORK_UNAVAILABLE` from `apiClient`).
 */
export function useOnlineStatus(): boolean {
  return useSyncExternalStore(subscribe, getSnapshot, () => true);
}
